<template>
  <v-card class="pa-4 linea-paros-card" elevation="1">
    <!-- ========== PARETO DE PAROS ========== -->
    <div v-if="paretoData.length" class="mb-4">
      <div class="px-4 pt-1 pb-2">
        <div class="subtitle-2 font-weight-medium">
          PARETO DE PAROS
        </div>
      </div>

      <!-- Botonera modos -->
      <div class="px-4 pb-3 d-flex justify-center">
        <div class="rounded-pill grey lighten-4 pa-1 d-inline-flex elevation-1">
          <v-btn small fab class="mx-1" :color="modoActual === 'minutos' ? 'primary' : null"
            :aria-pressed="modoActual === 'minutos'" @click="setModo('minutos')">
            <v-icon small :color="modoActual === 'minutos' ? 'white' : 'primary'">
              mdi-timer-outline
            </v-icon>
          </v-btn>

          <!-- <v-btn small fab class="mx-1" :color="modoActual === 'cantidad' ? 'primary' : null"
            :aria-pressed="modoActual === 'cantidad'" @click="setModo('cantidad')">
            <v-icon small :color="modoActual === 'cantidad' ? 'white' : 'primary'">
              mdi-pound
            </v-icon>
          </v-btn> -->

          <v-btn small fab class="mx-1" :color="modoActual === 'porcentaje' ? 'primary' : null"
            :aria-pressed="modoActual === 'porcentaje'" @click="setModo('porcentaje')">
            <v-icon small :color="modoActual === 'porcentaje' ? 'white' : 'primary'">
              mdi-percent-outline
            </v-icon>
          </v-btn>
        </div>
      </div>

      <div class="px-2">
        <apexchart type="bar" :options="paretoOpts" :series="paretoSeries" height="300" />
      </div>

      <v-divider class="my-4" />
    </div>

    <!-- ========== LÍNEA DEL TIEMPO VERTICAL CONTINUA ========== -->
    <div v-if="detalleHoras && detalleHoras.length" class="hora-timeline">
      <div class="subtitle-2 font-weight-medium mb-2 px-1">
        Historial de paros
      </div>

      <div class="hora-timeline-list">
        <div v-for="(h, idx) in detalleHoras" :key="idx" class="hora-timeline-row">
          <div class="hora-timeline-dot" :style="{ backgroundColor: h.color }" />
          <div class="hora-timeline-content">
            <div class="subtitle-2 grey--text text--darken-1 mb-1">
              {{ h.rango }}
            </div>
            <div class="h5 font-weight-medium">
              {{ h.descripcion }}
            </div>
            <!-- <div class="h6 grey--text">
              <span v-if="h.activoSeg > 0">Activo: {{ h.activoTxt }} </span>
              <span v-if="h.noProgSeg > 0">Paro NO Programado: {{ h.noProgTxt }} </span>
              <span v-if="h.progSeg > 0">Paro Programado: {{ h.progTxt }} </span>
            </div> -->
            <div class="h6 grey--text">
              <span v-if="h.actividadSeg > 0">Actividad: {{ h.actividadTxt }} </span>
              <span v-if="h.inactividadSeg > 0">Inactividad: {{ h.inactividadTxt }} </span>
              <span v-if="h.noProgSeg > 0">Paro NO Programado: {{ h.noProgTxt }} </span>
              <span v-if="h.progSeg > 0">Paro Programado: {{ h.progTxt }} </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ========== KPIs SUPERIORES ========== -->
    <!-- <v-row no-gutters class="mb-3 text-center">
      <v-col v-if="verActivo" cols="12" sm="3" class="mb-3 mb-sm-0">
        <div class="d-flex justify-center align-center mb-1">
          <span class="legend-dot" :style="{ backgroundColor: colors.activo }"></span>
          <span class="subtitle-2 font-weight-medium ml-1">
            Tiempo activo
          </span>
        </div>
        <div class="headline font-weight-bold">
          {{ formatDuration(totalActivoSeg) }}
        </div>
      </v-col>

      <v-col v-if="verNoProgramado" cols="12" sm="3" class="mb-3 mb-sm-0">
        <div class="d-flex justify-center align-center mb-1">
          <span class="legend-dot" :style="{ backgroundColor: colors.noProg }"></span>
          <span class="subtitle-2 font-weight-medium ml-1">
            Paro no programado
          </span>
        </div>
        <div class="headline font-weight-bold">
          {{ formatDuration(totalNoProgSeg) }}
        </div>
      </v-col>

      <v-col v-if="verProgramado" cols="12" sm="3" class="mb-3 mb-sm-0">
        <div class="d-flex justify-center align-center mb-1">
          <span class="legend-dot" :style="{ backgroundColor: colors.prog }"></span>
          <span class="subtitle-2 font-weight-medium ml-1">
            Paro programado
          </span>
        </div>
        <div class="headline font-weight-bold">
          {{ formatDuration(totalProgSeg) }}
        </div>
      </v-col>

      <v-col v-if="verSinEspecificar" cols="12" sm="3">
        <div class="d-flex justify-center align-center mb-1">
          <span class="legend-dot" :style="{ backgroundColor: colors.sinEsp }"></span>
          <span class="subtitle-2 font-weight-medium ml-1">
            Paro sin especificar
          </span>
        </div>
        <div class="headline font-weight-bold">
          {{ formatDuration(totalSinEspSeg) }}
        </div>
      </v-col>
    </v-row>

    <v-divider class="mb-3" /> -->

    <!-- ========== LÍNEA HORIZONTAL ========== -->
    <!-- <div class="timeline-wrapper mb-4">
      <div v-if="timelineSegments.length" class="timeline-track">
        <div v-for="(seg, idx) in timelineSegments" :key="idx" class="timeline-segment" :style="segmentStyle(seg)" />
      </div>
      <div v-else class="timeline-track timeline-empty d-flex align-center justify-center">
        <span class="caption grey--text text--darken-1">
          Sin datos de paros para el periodo
        </span>
      </div>

      <div v-if="axisLabels.length" class="timeline-axis mt-2">
        <div v-for="(label, idx) in axisLabels" :key="idx" class="axis-tick">
          <span class="caption grey--text text--darken-2">
            {{ label }}
          </span>
        </div>
      </div>
    </div> -->
  </v-card>
</template>

<script>
export default {
  name: 'LineaParosTurno',
  props: {
    horas: {
      type: Array,
      default: () => [],
    },
    verActivo: {
      type: Boolean,
      default: true,
    },
    verProgramado: {
      type: Boolean,
      default: true,
    },
    verNoProgramado: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      colors: {
        activo: '#26A69A',
        noProg: '#EF5350',
        prog: '#FFB300',
        sinEsp: '#7E57C2',
        inac: '#90CAF9',
      },
      modoActual: 'minutos', // 'minutos' | 'cantidad' | 'porcentaje'
    };
  },
  computed: {
    /* ===== RESUMEN PARA LA BARRA HORIZONTAL ===== */
    breakdown() {
      const source = Array.isArray(this.horas) ? this.horas : [];
      const horasTurno = source.filter(h => h && h.pasadoOEnCurso === true);

      if (!horasTurno.length) {
        return {
          segments: [],
          totalActivo: 0,
          totalNoProg: 0,
          totalProg: 0,
          totalSinEsp: 0,
          axisLabels: [],
        };
      }

      const ordenadas = horasTurno.slice();
      const segments = [];
      let totalActivo = 0;
      let totalNoProg = 0;
      let totalProg = 0;
      let totalSinEsp = 0;

      for (const h of ordenadas) {
        const durBloque = this.blockSeconds(h.desdeHora, h.hastaHora);
        if (!durBloque) continue;

        const segParoProg = Number(h.segundosParoProgramado || 0);
        const segParoNoProgTotal = Number(h.segundosParo || 0);

        const segSinEsp = this.segundosSinEspecificarEnHora(h);
        const segParoNoProgOtros = Math.max(segParoNoProgTotal - segSinEsp, 0);

        let segActivo = durBloque - segParoProg - segParoNoProgOtros - segSinEsp;
        if (segActivo < 0) segActivo = 0;

        if (segActivo > 0) {
          segments.push({ type: 'activo', seconds: segActivo });
          totalActivo += segActivo;
        }
        if (segParoNoProgOtros > 0) {
          segments.push({ type: 'noProg', seconds: segParoNoProgOtros });
          totalNoProg += segParoNoProgOtros;
        }
        if (segParoProg > 0) {
          segments.push({ type: 'prog', seconds: segParoProg });
          totalProg += segParoProg;
        }
        if (segSinEsp > 0) {
          segments.push({ type: 'sinEsp', seconds: segSinEsp });
          totalSinEsp += segSinEsp;
        }
      }

      const axisLabels = this.buildAxisLabels(ordenadas);

      return {
        segments,
        totalActivo,
        totalNoProg,
        totalProg,
        totalSinEsp,
        axisLabels,
      };
    },
    timelineSegments() {
      const allowed = new Set();
      if (this.verActivo) allowed.add('activo');
      if (this.verNoProgramado) allowed.add('noProg');
      if (this.verProgramado) allowed.add('prog');
      if (this.verSinEspecificar) allowed.add('sinEsp');

      return this.breakdown.segments.filter(seg => allowed.has(seg.type));
    },
    axisLabels() {
      return this.breakdown.axisLabels;
    },
    totalActivoSeg() {
      return this.breakdown.totalActivo;
    },
    totalNoProgSeg() {
      return this.breakdown.totalNoProg;
    },
    totalProgSeg() {
      return this.breakdown.totalProg;
    },
    totalSinEspSeg() {
      return this.breakdown.totalSinEsp;
    },
    verSinEspecificar() {
      return this.breakdown.totalSinEsp > 0;
    },

    /* ===== LÍNEA DEL TIEMPO CONTINUA ===== */
    detalleHoras() {
      const source = Array.isArray(this.horas) ? this.horas : [];
      const horasTurno = source.filter(h => h && h.pasadoOEnCurso === true);
      if (!horasTurno.length) return [];

      // --- Inicio y fin global del turno ---
      const first = horasTurno[0];
      const last = horasTurno[horasTurno.length - 1];

      const fechaFirst = first.fecha || first.Fecha;
      const fechaLast = last.fecha || last.Fecha;

      let inicioGlobal = this.parseDateTime(fechaFirst, first.desdeHora);
      let finGlobal = this.parseDateTime(fechaLast, last.hastaHora);

      // Turnos que cruzan medianoche
      if (finGlobal <= inicioGlobal) {
        finGlobal = new Date(finGlobal.getTime() + 24 * 60 * 60 * 1000);
      }

      // --- Paros reales ya recortados por hora (inicioBloque / finBloque) ---
      const eventosParo = [];

      const addParo = (p, esProgramado) => {
        if (!p || !p.inicioBloque || !p.finBloque) return;

        const ini = new Date(p.inicioBloque);
        const fin = new Date(p.finBloque);
        if (!(fin > ini)) return;

        const sec = (fin - ini) / 1000;
        if (sec <= 0) return;

        eventosParo.push({
          type: esProgramado ? 'prog' : 'noProg',
          start: ini,
          end: fin,
          seconds: sec,
          causa: p.causa || '',
          subCausa: p.subCausa || '',
        });
      };

      for (const h of horasTurno) {
        const progs = Array.isArray(h.parosProgramados) ? h.parosProgramados : [];
        const noprogs = Array.isArray(h.parosNoProgramados) ? h.parosNoProgramados : [];

        progs.forEach(p => addParo(p, true));
        noprogs.forEach(p => addParo(p, false));
      }

      // Si no hay ningún paro: un sólo bloque activo todo el turno
      if (!eventosParo.length) {
        const seconds = (finGlobal - inicioGlobal) / 1000;
        return [{
          rango: `${this.dateToHHmm(inicioGlobal)} - ${this.dateToHHmm(finGlobal)}`,
          descripcion: 'Tiempo activo',
          color: this.colors.activo,
          activoTxt: this.formatDuration(seconds),
          activoSeg: seconds,
          noProgTxt: this.formatDuration(0),
          noProgSeg: 0,
          progTxt: this.formatDuration(0),
          progSeg: 0,
        }];
      }

      // --- Unión de intervalos de paro (sin importar si son prog / no prog) ---
      const intervals = eventosParo
        .map(e => ({ start: e.start, end: e.end }))
        .sort((a, b) => a.start - b.start);

      const union = [];
      for (const iv of intervals) {
        if (!union.length) {
          union.push({ start: new Date(iv.start), end: new Date(iv.end) });
        } else {
          const lastIv = union[union.length - 1];
          if (iv.start <= lastIv.end) {
            if (iv.end > lastIv.end) lastIv.end = new Date(iv.end);
          } else {
            union.push({ start: new Date(iv.start), end: new Date(iv.end) });
          }
        }
      }

      // --- Complemento = segmentos activos reales ---
      const activos = [];
      let cursor = new Date(inicioGlobal);

      for (const iv of union) {
        if (iv.start > cursor) {
          activos.push({
            type: 'activo',
            start: new Date(cursor),
            end: new Date(iv.start),
          });
        }
        if (iv.end > cursor) cursor = new Date(iv.end);
      }
      if (cursor < finGlobal) {
        activos.push({
          type: 'activo',
          start: new Date(cursor),
          end: new Date(finGlobal),
        });
      }

      // --- Mezclar activos + paros ---
      const allSegs = [];

      // Activos
      activos.forEach(a => {
        const sec = (a.end - a.start) / 1000;
        if (sec <= 0) return;
        allSegs.push({
          type: 'activo',
          start: a.start,
          end: a.end,
          seconds: sec,
          label: 'Tiempo activo',
        });
      });

      // Paros (cada evento trae su causa/subcausa)
      eventosParo.forEach(e => {
        allSegs.push({
          type: e.type,
          start: e.start,
          end: e.end,
          seconds: e.seconds,
          label: this.labelParoEvento(e.causa, e.subCausa, e.type === 'prog'),
        });
      });

      // Ordenar por tiempo y unir tramos contiguos con mismo tipo/label
      allSegs.sort((a, b) => a.start - b.start || a.end - b.end);

      const merged = [];
      for (const seg of allSegs) {
        if (!merged.length) {
          merged.push({ ...seg });
          continue;
        }
        const last = merged[merged.length - 1];

        if (
          last.type === seg.type &&
          last.label === seg.label &&
          last.end.getTime() === seg.start.getTime()
        ) {
          // mismo tipo/causa y pegados → se juntan
          last.end = seg.end;
          last.seconds += seg.seconds;
        } else {
          merged.push({ ...seg });
        }
      }
      // --- Calcular actividad e inactividad por segmento a partir de las horas originales ---
      const horasInfo = horasTurno.map(h => {
        const fecha = h.fecha || h.Fecha;
        const start = this.parseDateTime(fecha, h.desdeHora);
        let end = this.parseDateTime(fecha, h.hastaHora);
        if (end <= start) {
          end = new Date(end.getTime() + 24 * 60 * 60 * 1000); // cruza medianoche
        }

        const inact = Number(
          h.segundosInactividadDisponible ??
          h.SegundosInactividadDisponible ??
          0
        ) || 0;

        return {
          start,
          end,
          inact,
          activeSegs: 0, // se llena abajo
        };
      });

      const overlapSec = (aStart, aEnd, bStart, bEnd) => {
        const s = aStart > bStart ? aStart : bStart;
        const e = aEnd < bEnd ? aEnd : bEnd;
        const diff = (e - s) / 1000;
        return diff > 0 ? diff : 0;
      };

      // 1) Segundos activos por hora (solo segmentos de tipo 'activo')
      for (const hi of horasInfo) {
        let active = 0;
        for (const seg of merged) {
          if (seg.type !== 'activo') continue;
          active += overlapSec(seg.start, seg.end, hi.start, hi.end);
        }
        hi.activeSegs = active;
      }

      // 2) Distribuir la inactividad de cada hora en los segmentos activos que la pisan
      for (const seg of merged) {
        if (seg.type !== 'activo') {
          seg.inactividadSeg = 0;
          seg.actividadSeg = 0;
          continue;
        }

        let inactSeg = 0;
        for (const hi of horasInfo) {
          const overlap = overlapSec(seg.start, seg.end, hi.start, hi.end);
          if (!overlap || hi.activeSegs <= 0 || hi.inact <= 0) continue;

          const prop = overlap / hi.activeSegs; // proporción del tiempo activo de esa hora
          inactSeg += hi.inact * prop;
        }

        seg.inactividadSeg = inactSeg;
        seg.actividadSeg = Math.max(seg.seconds - inactSeg, 0);
      }

      // --- Formato que ya usa el template ---
      return merged.map(seg => {
        const rango = `${this.dateToHHmm(seg.start)} - ${this.dateToHHmm(seg.end)}`;
        const segundos = seg.seconds;

        const actividadSeg = seg.actividadSeg || 0;
        const inactividadSeg = seg.inactividadSeg || 0;

        let color;
        let activoSeg = 0;
        let noProgSeg = 0;
        let progSeg = 0;

        if (seg.type === 'activo') {
          color = this.colors.activo;
          activoSeg = segundos; // activo total (actividad + inactividad)
        } else if (seg.type === 'noProg') {
          color = this.colors.noProg;
          noProgSeg = segundos;
        } else {
          color = this.colors.prog;
          progSeg = segundos;
        }

        return {
          rango,
          descripcion: seg.label,
          color,

          // Totales que ya usabas (por compatibilidad)
          activoTxt: this.formatDuration(activoSeg),
          activoSeg,
          noProgTxt: this.formatDuration(noProgSeg),
          noProgSeg,
          progTxt: this.formatDuration(progSeg),
          progSeg,

          // Nuevos campos para el texto “Actividad / Inactividad”
          actividadTxt: this.formatDuration(actividadSeg),
          actividadSeg,
          inactividadTxt: this.formatDuration(inactividadSeg),
          inactividadSeg,
        };
      });
    },
    /* ===== PARETO ===== */
    paretoData() {
      const source = Array.isArray(this.horas) ? this.horas : [];
      const horasTurno = source.filter(h => h && h.pasadoOEnCurso === true);

      const grupos = new Map();
      let totalSegundos = 0;

      const acumula = (paro, esProgramado) => {
        const causa = (paro?.causa || 'SIN CAUSA').trim() || 'SIN CAUSA';
        const key = this.normaliza(causa);
        let g = grupos.get(key);
        if (!g) {
          g = {
            key,
            label: causa,
            tiempo: 0,
            eventos: 0,
            esProgramado,
            esMixto: false,
          };
          grupos.set(key, g);
        }

        const seg = Number(paro.duracionSegEnBloque ?? paro.duracionSeg ?? 0) || 0;
        const ev = Number(paro.cantidadRegistros ?? paro.eventos ?? 1) || 1;

        g.tiempo += seg;
        g.eventos += ev;
        totalSegundos += seg;

        if (g.esProgramado !== esProgramado) {
          g.esMixto = true;
        }
      };

      for (const h of horasTurno) {
        const progs = Array.isArray(h.parosProgramados) ? h.parosProgramados : [];
        const noprogs = Array.isArray(h.parosNoProgramados) ? h.parosNoProgramados : [];

        for (const p of progs) acumula(p, true);
        for (const p of noprogs) acumula(p, false);
      }

      const arr = Array.from(grupos.values()).filter(g => g.tiempo > 0);
      if (!arr.length) return [];

      for (const g of arr) {
        g.minutos = Math.round(g.tiempo / 60);
        g.porcentaje = totalSegundos > 0 ? (g.tiempo * 100) / totalSegundos : 0;
        const tipoProg = g.esMixto ? false : g.esProgramado;
        g.color = tipoProg ? this.colors.prog : this.colors.noProg;
      }

      return arr;
    },
    paretoOrdenados() {
      return [...this.paretoData].sort((a, b) => b.tiempo - a.tiempo);
    },
    paretoCategorias() {
      return this.paretoOrdenados.map(g => {
        const txt = g.label || '';
        return txt.length > 18 ? txt.slice(0, 18) + '…' : txt;
      });
    },
    paretoSeries() {
      const orden = this.paretoOrdenados;
      if (!orden.length) return [];

      let data;
      let name;

      if (this.modoActual === 'porcentaje') {
        data = orden.map(g => Number(g.porcentaje.toFixed(2)));
        name = '% del tiempo de paro';
      } else if (this.modoActual === 'cantidad') {
        data = orden.map(g => g.eventos);
        name = 'Eventos de paro';
      } else {
        data = orden.map(g => g.minutos);
        name = 'Minutos de paro';
      }

      return [{ name, data }];
    },
    paretoColors() {
      const orden = this.paretoOrdenados;
      return orden.map(g => g.color || this.colors.noProg);
    },
    paretoOpts() {
      if (!this.paretoSeries.length) return {};

      const orden = this.paretoOrdenados;
      const serie = this.paretoSeries[0];

      return {
        chart: { type: 'bar', toolbar: { show: false } },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: true,
            barHeight: '60%',
            borderRadius: 6,
            dataLabels: { position: 'right' },
          },
        },
        colors: this.paretoColors,
        xaxis: {
          categories: this.paretoCategorias,
          title: { text: serie.name },
        },
        yaxis: {
          labels: { style: { fontSize: '12px' } },
        },
        dataLabels: {
          enabled: true,
          style: { fontSize: '12px', fontWeight: 700, colors: ['#000'] },
          background: {
            enabled: true,
            foreColor: '#fff',
            borderRadius: 4,
            padding: 4,
            opacity: 1,
            borderWidth: 0,
            borderColor: '#fff',
            dropShadow: { enabled: false },
          },
          formatter: (val) =>
            this.modoActual === 'porcentaje'
              ? `${Number(val).toFixed(2)}%`
              : this.modoActual === 'minutos'
                ? `${val} min`
                : `${val}`,
        },
        tooltip: {
          y: {
            formatter: (val, opts) => {
              const d = orden[opts.dataPointIndex] || {};
              const minutos = Math.round((Number(d.tiempo) || 0) / 60);
              const pct = (Number(d.porcentaje) || 0).toFixed(2);
              const ev = Number(d.eventos ?? d.cantidad ?? val);
              return `${ev} eventos • ${minutos} min • ${pct}%`;
            },
          },
        },
        grid: { padding: { left: 6, right: 6 } },
      };
    },
  },
  methods: {
    timeToMinutes(hhmm) {
      if (!hhmm || typeof hhmm !== 'string') return 0;
      const [h, m] = hhmm.split(':').map(v => parseInt(v, 10) || 0);
      return h * 60 + m;
    },
    blockSeconds(desde, hasta) {
      const from = this.timeToMinutes(desde);
      const to = this.timeToMinutes(hasta);
      if (isNaN(from) || isNaN(to)) return 0;
      const diffMin = to >= from ? (to - from) : (to + 24 * 60 - from);
      return diffMin * 60;
    },
    buildAxisLabels(horasOrdenadas) {
      const labels = [];
      const seen = new Set();

      for (const h of horasOrdenadas) {
        const d = (h.desdeHora || '').trim();
        if (d && !seen.has(d)) {
          seen.add(d);
          labels.push(d);
        }
      }

      const last = horasOrdenadas[horasOrdenadas.length - 1];
      if (last && last.hastaHora) {
        const fin = last.hastaHora.trim();
        if (fin && !seen.has(fin)) labels.push(fin);
      }

      return labels;
    },
    normaliza(txt) {
      return (txt || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
    },
    esSinEspecificar(paro) {
      const txt = this.normaliza(
        `${paro?.causa || ''} ${paro?.subCausa || ''}`,
      );
      return txt.includes('sin especificar');
    },
    segundosSinEspecificarEnHora(h) {
      let total = 0;
      const arr = Array.isArray(h.parosNoProgramados) ? h.parosNoProgramados : [];
      for (const p of arr) {
        if (!this.esSinEspecificar(p)) continue;
        const seg = Number(p.duracionSegEnBloque ?? p.duracionSeg ?? 0);
        if (Number.isFinite(seg) && seg > 0) total += seg;
      }
      return total;
    },
    segmentStyle(seg) {
      const base = {
        flexGrow: seg.seconds || 0,
        flexBasis: 0,
      };

      switch (seg.type) {
        case 'activo': return { ...base, backgroundColor: this.colors.activo };
        case 'noProg': return { ...base, backgroundColor: this.colors.noProg };
        case 'prog': return { ...base, backgroundColor: this.colors.prog };
        case 'sinEsp': return { ...base, backgroundColor: this.colors.sinEsp };
        default: return base;
      }
    },
    formatDuration(segundos) {
      const totalMin = Math.round((Number(segundos) || 0) / 60);
      const h = Math.floor(totalMin / 60);
      const m = totalMin % 60;
      return h > 0 ? `${h} h ${m} min` : `${m} min`;
    },
    setModo(modo) {
      this.modoActual = modo;
    },
    labelParo(paros, esProgramado) {
      const arr = Array.isArray(paros) ? paros : [];
      if (!arr.length) {
        return esProgramado ? 'Paro programado' : 'Paro no programado';
      }

      // Filtra "sin especificar" para elegir causa dominante, pero si solo hay esos, se usan
      const valid = arr.filter(p => !this.esSinEspecificar(p));
      const list = valid.length ? valid : arr;

      let best = list[0];
      let bestDur = Number(best.duracionSegEnBloque ?? best.duracionSeg ?? 0) || 0;

      for (let i = 1; i < list.length; i++) {
        const p = list[i];
        const d = Number(p.duracionSegEnBloque ?? p.duracionSeg ?? 0) || 0;
        if (d > bestDur) {
          best = p;
          bestDur = d;
        }
      }

      const causa = (best.causa || '').trim();
      const sub = (best.subCausa || '').trim();

      if (causa && sub) return `${causa} - ${sub}`;
      if (causa) return causa;
      if (sub) return sub;

      return esProgramado ? 'Paro programado' : 'Paro no programado';
    },
    parseDateTime(fecha, hhmm) {
      const f = (fecha || '').slice(0, 10);
      const h = (hhmm || '00:00').slice(0, 5);
      // Asume zona local del navegador
      return new Date(`${f}T${h}:00`);
    },
    dateToHHmm(dt) {
      const d = dt instanceof Date ? dt : new Date(dt);
      if (!d || isNaN(d.getTime())) return '--:--';
      const hh = String(d.getHours()).padStart(2, '0');
      const mm = String(d.getMinutes()).padStart(2, '0');
      return `${hh}:${mm}`;
    },
    labelParoEvento(causa, subCausa, esProgramado) {
      const c = (causa || '').trim();
      const s = (subCausa || '').trim();
      if (c && s) return `${c} - ${s}`;
      if (c) return c;
      if (s) return s;
      return esProgramado ? 'Paro programado' : 'Paro no programado';
    },
  },
};
</script>

<style scoped>
.linea-paros-card {
  border-radius: 8px;
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

/* Línea horizontal */
.timeline-wrapper {
  width: 100%;
}

.timeline-track {
  width: 100%;
  height: 36px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  background-color: #e0e0e0;
}

.timeline-empty {
  background-color: #f5f5f5;
}

.timeline-segment {
  height: 100%;
}

.timeline-axis {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}

.axis-tick {
  text-align: center;
  min-width: 0;
}

/* Timeline vertical */
.hora-timeline {
  margin-top: 8px;
}

.hora-timeline-list {
  position: relative;
  padding-left: 32px;
}

.hora-timeline-list::before {
  content: "";
  position: absolute;
  left: 16px;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: #e0e0e0;
}

.hora-timeline-row {
  display: flex;
  position: relative;
  margin-bottom: 18px;
}

.hora-timeline-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.12);
  position: absolute;
  left: 9px;
  top: 4px;
}

.hora-timeline-content {
  margin-left: 24px;
  flex: 1;
}
</style>